import { modalController } from '@ionic/core';
import { PersonDoc } from 'common';
import { ConcoursePersonInviteProps } from './concourse-person-invite';

export class ConcoursePersonInviteController {
  static async presentModal(props: ConcoursePersonInviteProps): Promise<PersonDoc | void> {
    const modal = await modalController.create({
      component: 'concourse-person-invite',
      cssClass: 'modal-height-auto',
      backdropDismiss: false,
      componentProps: props,
    });
    return new Promise<PersonDoc>(async resolve => {
      modal.addEventListener('invited', (event: CustomEvent) => {
        const person: PersonDoc = event.detail;
        resolve(person);
        modal.dismiss();
      });

      modal.addEventListener('dismiss', () => {
        resolve(null);
        modal.dismiss();
      });

      await modal.present();
    });
  }
}
